import React from 'react';
import { cn } from '@/lib/utils';


const fontSizes = {
  xs: 'text-xs',        
  sm: 'text-sm',        
  base: 'text-base',    
  lg: 'text-lg',        
  xl: 'text-xl',        
  '2xl': 'text-2xl',    
  '3xl': 'text-3xl',    
  '4xl': 'text-4xl',    
};

const fontWeights = {
  thin: 'font-thin',        
  extralight: 'font-extralight', 
  light: 'font-light',      
  normal: 'font-normal',    
  medium: 'font-medium',    
  semibold: 'font-semibold', 
  bold: 'font-bold',        
  extrabold: 'font-extrabold', 
  black: 'font-black',      
};


export function CommonLabel({ 
  children, 
  className, 
  size = 'base', 
  weight = 'normal',
  ...props 
}) {
  return (
    <span
      className={cn(
        'text-foreground',
        fontSizes[size],
        fontWeights[weight],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export default CommonLabel;